import { render, staticRenderFns } from "./HrAssetDiscountCreate.vue?vue&type=template&id=6405a16a&lang=pug&"
import script from "./HrAssetDiscountCreate.vue?vue&type=script&lang=js&"
export * from "./HrAssetDiscountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrAssetDiscountCreate.vue"
export default component.exports